import { useState } from "react";
import { FormTreeSelection } from "../../../cpm/FormTree";
import { useDropDownModalStyles } from "../../useDropDownModalStyles";
import { DBApplication, FormTable } from "../../../interfaces/CoObject";

interface FormDropDownProps {
  form: FormTable | null;
  dbApplication: DBApplication | null;
  onFormClick: (selection: FormTreeSelection) => void;
  objectSource?: string;
  isComponentInstance?: boolean;
  isLocked?: boolean;
}

const useFormDropDown = (input: FormDropDownProps) => {
  const { form, dbApplication, objectSource, isComponentInstance = false, isLocked = false } = input;
  const { contentStyles, iconButtonStyles, cancelIcon, onRenderCaretDown } =
    useDropDownModalStyles(isComponentInstance);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  function onFormClick(formSelection: FormTreeSelection) {
    setIsModalOpen(false);
    input.onFormClick(formSelection);
  }

  return {
    form,
    onRenderCaretDown,
    setIsModalOpen,
    dbApplication,
    objectSource,
    isModalOpen,
    contentStyles,
    iconButtonStyles,
    cancelIcon,
    onFormClick,
    isComponentInstance,
    isLocked,
  };
};

export default useFormDropDown;
